<template>
  <div id="app">
    <!-- <router-view :key="this.$route.fullPath" class="content" /> -->
    <router-view class="content" />
    <Footer
      v-if="
        this.$route.name !== 'login' && //登录页
        this.$route.name !== 'appTojoin' && //申请加入页
        this.$route.name !== 'myEstimate' && //评估页
        this.$route.name !== 'undercarriage' && //课程已下架页
        this.$route.name !== 'payText' //图文详情-付费
      "
    ></Footer>
  </div>
</template>
<script>
import Footer from '@/components/Footer/index.vue';
export default {
  name: 'app',
  components: { Footer },
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {
    // 页面在pc端设置宽度并居中显示
    pcToTel() {
      if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        let html = document.getElementsByTagName('html')[0];
        let body = document.getElementsByTagName('body')[0];
        let foot = document.querySelector('.foot');
        console.log(foot);
        html.style.cssText = 'font-size:50px';
        body.style.cssText = 'max-width:480px;margin:0 auto;';
        foot.style.cssText =
          'max-width:480px;left: 50%;transform: translate(-50%, 0);';
      }
    },
  },
  created() {},
  mounted() {
    this.pcToTel();
  },
};
</script>
<style lang="less" scoped>
#app {
  width: 100%;
  background-color: #fff;
}
.content {
  padding-bottom: calc(
    50px + constant(safe-area-inset-bottom)
  ); // 兼容 IOS<11.2/
  padding-bottom: calc(50px + env(safe-area-inset-bottom)); // 兼容 IOS>11.2/
}
</style>
